import { render, staticRenderFns } from "./StepsComponent.vue?vue&type=template&id=aff8f24a&"
import script from "./StepsComponent.vue?vue&type=script&lang=js&"
export * from "./StepsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports